import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import EDIT_MODES from './editModes';
import _ from 'lodash';
import template from './itemRow.jsx';
import displayNames from '../displayNames';
import deleteIcon from '../icons/sbdl_delete.svg.js';
import duplicateIcon from '../icons/sbdl_duplicate.svg.js';
import editIcon from '../icons/sbdl_edit.svg.js';
import renameIcon from '../icons/sbdl_rename.svg.js';
import setAsDefaultIcon from '../icons/sbdl_setAsDefault.svg.js';
import compose from '../../hoc/compose';
import ContextMenuAction from '../contextMenuAction';
import _Symbol from '../symbol';
var SYMBOLS_MAP = {
  toggleDefault: setAsDefaultIcon,
  duplicate: duplicateIcon,
  toggleEditLabel: renameIcon,
  toggleEditValue: editIcon,
  "delete": deleteIcon
};
var DEFAULT_LABEL_PLACEHOLDER = 'Add label here';
var DEFAULT_VALUE_PLACEHOLDER = 'Add value here';

var ItemRow = /*#__PURE__*/function (_React$Component) {
  _inherits(ItemRow, _React$Component);

  var _super = _createSuper(ItemRow);

  function ItemRow(props) {
    var _this;

    _classCallCheck(this, ItemRow);

    _this = _super.call(this, props);

    _this.shouldShowDragHandle = function () {
      return _this.props.withDragHandle && !_this.isEditMode();
    };

    _this.isEditMode = function () {
      return _this.props.editMode !== EDIT_MODES.NONE;
    };

    _this.editLabelMode = function () {
      return _this.props.editMode === EDIT_MODES.EDIT_LABEL;
    };

    _this.editValueMode = function () {
      return _this.props.editMode === EDIT_MODES.EDIT_VALUE;
    };

    _this.hasValue = function () {
      return _.has(_this.props.value, 'value') && _this.props.value.value !== undefined;
    };

    _this.getRowClasses = function () {
      var classes = _({
        selectable: _this.selectable(),
        selected: _this.props.isSelected,
        disabled: _this.props.disabled,
        'has-value': _this.hasValue(),
        draggable: _this.props.draggable,
        'edit-mode': _this.editLabelMode() || _this.editValueMode(),
        withDragHandle: _this.shouldShowDragHandle(),
        bold: _this.props.isDefault,
        dragging: _this.props.isDragging,
        'custom-row': _this.props.contentBefore || _this.props.contentAfter
      }).pickBy().keys().value();

      return _this.props.getClassName('sbdl-item-row') + ' ' + classes.join(' ');
    };

    _this.getViewModeClasses = function () {
      var dynamicHeightClass = _this.props.dynamicHeight ? ' dynamic-height' : '';
      return "view-mode-content".concat(dynamicHeightClass);
    };

    _this.getContentBeforeClasses = function () {
      var dynamicWidthClass = _this.props.dynamicWidth ? ' dynamic-width' : '';
      return "content-before".concat(dynamicWidthClass);
    };

    _this.getLabelClasses = function () {
      return {
        label: true,
        placeholder: _.isEmpty(_this.props.value.label)
      };
    };

    _this.getValueClasses = function () {
      return {
        value: true,
        placeholder: _this.shouldShowValuePlaceholder()
      };
    };

    _this.selectable = function () {
      return _.isFunction(_this.props.select) && !_this.props.isDragging && !_this.props.isSelected;
    };

    _this.select = function () {
      if (!_this.props.disabled && _this.selectable()) {
        _this.props.select();
      }
    };

    _this.closeEditLabelMode = function () {
      return _this.props.menuActions.toggleEditLabel.action();
    };

    _this.closeEditValueMode = function () {
      return _this.props.menuActions.toggleEditValue.action();
    };

    _this.getLabelMaxLength = function () {
      return _this.props.menuActions.toggleEditLabel.labelMaxLength;
    };

    _this.getValueMaxLength = function () {
      return _this.props.menuActions.toggleEditValue.valueMaxLength;
    };

    _this.getLabelPlaceHolder = function () {
      return _.isUndefined(_this.props.labelPlaceholder) ? DEFAULT_LABEL_PLACEHOLDER : _this.props.translateIfNeeded(_this.props.labelPlaceholder);
    };

    _this.shouldShowLabelPlaceholder = function () {
      return !_.has(_this.props, 'labelPrefix') && _.isEmpty(_this.props.value.label);
    };

    _this.getLabelToDisplay = function () {
      var _this$props = _this.props,
          labelPrefix = _this$props.labelPrefix,
          labelToDisplay = _this$props.labelToDisplay,
          itemValue = _this$props.value;
      var prefix = labelPrefix ? labelPrefix + ': ' : '';
      var label = _this.shouldShowLabelPlaceholder() ? _this.getLabelPlaceHolder() : itemValue.label;
      return labelToDisplay ? labelToDisplay(label) : prefix + label;
    };

    _this.getValuePlaceHolder = function () {
      return _.isUndefined(_this.props.valuePlaceholder) ? DEFAULT_VALUE_PLACEHOLDER : _this.props.translateIfNeeded(_this.props.valuePlaceholder);
    };

    _this.shouldShowValuePlaceholder = function () {
      return !_.has(_this.props, 'valuePrefix') && _.isEmpty(_this.props.value.value);
    };

    _this.getValueToDisplay = function () {
      var _this$props2 = _this.props,
          valuePrefix = _this$props2.valuePrefix,
          valueToDisplay = _this$props2.valueToDisplay,
          itemValue = _this$props2.value;
      var prefix = valuePrefix ? valuePrefix + ': ' : '';
      var value = _this.shouldShowValuePlaceholder() ? _this.getValuePlaceHolder() : itemValue.value;
      return valueToDisplay ? valueToDisplay(value) : prefix + value;
    };

    _this.updateLabelAndCloseEditMode = function (newLabel) {
      var newVal = _.defaults({
        label: newLabel
      }, _this.props.value);

      _this.props.onChange(newVal);

      _this.closeEditLabelMode();
    };

    _this.updateValueAndCloseEditMode = function (newValue) {
      var newVal = _.defaults({
        value: newValue
      }, _this.props.value);

      _this.props.onChange(newVal);

      _this.closeEditValueMode();
    };

    _this.onDoubleClick = function () {
      if (_.has(_this.props.menuActions, 'toggleEditLabel')) {
        _this.props.menuActions.toggleEditLabel.action();
      }
    };

    _this.hasContextMenu = function () {
      return !_.isEmpty(_this.props.menuActions) || !_.isEmpty(_this.props.children);
    };

    _this.getDefaultContextMenuActions = function () {
      var isRemovable = function isRemovable() {
        return _.isUndefined(_this.props.value.removable) || _this.props.value.removable;
      };

      var shouldShowAction = function shouldShowAction(menuAction) {
        return menuAction.key !== 'delete' || isRemovable();
      };

      return _(_this.props.menuActions).map(function (menuAction, menuActionKey) {
        return {
          label: _.isFunction(menuAction.label) ? menuAction.label(_this.props.value) : menuAction.label,
          symbol: SYMBOLS_MAP[menuActionKey],
          key: menuActionKey,
          onClick: menuAction.action,
          automationId: menuAction.automationId,
          dataHook: menuAction.dataHook,
          priority: menuAction.priority,
          disabled: menuAction.disabled
        };
      }).filter(shouldShowAction).map(function (actionProps) {
        return /*#__PURE__*/React.createElement(ContextMenuAction, actionProps, [/*#__PURE__*/React.createElement(_Symbol, {
          key: 'symbol'
        }, /*#__PURE__*/React.createElement(actionProps.symbol)), actionProps.label]);
      }).value();
    };

    _this.getAllContextMenuActions = function () {
      var dynamicItemsGetter = _this.props.dynamicItemsGetter || _.identity;

      var childrenArray = _([]).concat(_this.props.children).compact().value();

      var childrenWithPriority = _.reject(childrenArray, function (c) {
        return _.isUndefined(c.props.priority);
      });

      var childrenWithoutPriority = _.filter(childrenArray, function (c) {
        return _.isUndefined(c.props.priority);
      });

      return _(_this.getDefaultContextMenuActions()).concat(childrenWithPriority).sortBy('props.priority').reverse().concat(childrenWithoutPriority).thru(dynamicItemsGetter).value();
    };

    _this.getTextWidth = function () {
      return "calc(100% - ".concat(!_.isEmpty(_this.props.contentBefore) * 56 + !_.isEmpty(_this.props.contentAfter) * 24, "px)");
    };

    _this.onHover = function () {
      if (_.isFunction(_this.props.onHover)) {
        _this.props.onHover(_this.props.value);
      }
    };

    _this.isMultiline = function () {
      return _this.props.className ? _this.props.className.includes('multiline') : false;
    };

    return _this;
  }

  _createClass(ItemRow, [{
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return ItemRow;
}(React.Component);

ItemRow.displayName = displayNames.SORT_BY_DRAG_LIST_ITEM_ROW;
ItemRow.propTypes = {
  value: PropTypes.oneOfType([PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string
  }), PropTypes.shape({
    content: PropTypes.element.isRequired
  })]).isRequired,
  valueDescription: PropTypes.func,
  labelDescription: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onHover: PropTypes.func,
  editMode: PropTypes.oneOf([EDIT_MODES.NONE, EDIT_MODES.EDIT_LABEL, EDIT_MODES.EDIT_VALUE]),
  select: PropTypes.func,
  disabled: PropTypes.bool,
  draggable: PropTypes.bool,
  withDragHandle: PropTypes.bool,
  dragHandleEnabled: PropTypes.bool,
  dragHandleTooltipContent: PropTypes.string,
  isDefault: PropTypes.bool,
  isSelected: PropTypes.bool,
  isDragging: PropTypes.bool,
  labelPlaceholder: PropTypes.string,
  valuePlaceholder: PropTypes.string,
  submitEditLabelButtonText: PropTypes.node,
  submitEditValueButtonText: PropTypes.node,
  shouldTranslateInvalidLabelMessage: PropTypes.bool,
  shouldTranslateInvalidValueMessage: PropTypes.bool,
  labelValidators: PropTypes.arrayOf(PropTypes.shape({
    validator: PropTypes.func.isRequired,
    invalidMessage: PropTypes.string.isRequired
  })),
  valueValidators: PropTypes.arrayOf(PropTypes.shape({
    validator: PropTypes.func.isRequired,
    invalidMessage: PropTypes.string.isRequired
  })),
  valuePrefix: PropTypes.string,
  labelPrefix: PropTypes.string,
  menuActions: PropTypes.shape({
    toggleDefault: PropTypes.shape({
      label: PropTypes.func.isRequired,
      action: PropTypes.func.isRequired,
      priority: PropTypes.number.isRequired,

      /**
       * Automation ID - for testing purposes, please use dataHook instead
       * @deprecated
       */
      automationId: PropTypes.string,
      dataHook: PropTypes.string,
      disabled: PropTypes.bool
    }),
    duplicate: PropTypes.shape({
      label: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired,
      priority: PropTypes.number.isRequired,

      /**
       * Automation ID - for testing purposes, please use dataHook instead
       * @deprecated
       */
      automationId: PropTypes.string,
      dataHook: PropTypes.string,
      disabled: PropTypes.bool
    }),
    toggleEditLabel: PropTypes.shape({
      label: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired,
      priority: PropTypes.number.isRequired,
      labelMaxLength: PropTypes.number,

      /**
       * Automation ID - for testing purposes, please use dataHook instead
       * @deprecated
       */
      automationId: PropTypes.string,
      dataHook: PropTypes.string,
      disabled: PropTypes.bool
    }),
    toggleEditValue: PropTypes.shape({
      label: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired,
      priority: PropTypes.number.isRequired,
      valueMaxLength: PropTypes.number,

      /**
       * Automation ID - for testing purposes, please use dataHook instead
       * @deprecated
       */
      automationId: PropTypes.string,
      dataHook: PropTypes.string,
      disabled: PropTypes.bool
    }),
    "delete": PropTypes.shape({
      label: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired,
      priority: PropTypes.number.isRequired,

      /**
       * Automation ID - for testing purposes, please use dataHook instead
       * @deprecated
       */
      automationId: PropTypes.string,
      dataHook: PropTypes.string,
      disabled: PropTypes.bool
    })
  }),
  contentBefore: PropTypes.element,
  contentAfter: PropTypes.element,
  customAction: PropTypes.element,
  isContextMenuOpen: PropTypes.bool,
  onContextMenuToggle: PropTypes.func,
  contextMenuAlignment: PropTypes.string,
  contextMenuDirection: PropTypes.string,
  dynamicHeight: PropTypes.bool,
  dynamicWidth: PropTypes.bool,
  dynamicItemsGetter: PropTypes.func
};
ItemRow.defaultProps = {
  editMode: EDIT_MODES.NONE,
  disabled: false,
  draggable: true,
  withDragHandle: true,
  dragHandleEnabled: true,
  isDefault: false,
  isSelected: false,
  isDragging: false,
  dynamicHeight: false,
  dynamicWidth: false,
  menuActions: {}
};
export default compose(ItemRow);